// Styled for theme
export default {}